import Pagination, { PaginationProps } from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { FC } from 'react';
import styles from './style.module.scss';

const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="24" height="24" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0)" fill="white" />
      <path
        d="M10.2861 6.02539L15.741 11.4802C16.0757 11.815 16.0757 12.3577 15.741 12.6924L10.2861 18.1472"
        stroke="#484C70"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const PREV_ICON = (
  <ArrowIcon className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rotate-180" />
);

const NEXT_ICON = <ArrowIcon className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]" />;

const WkPagination: FC<PaginationProps> = (props) => {
  return (
    <div className={styles.wukPagination}>
      <Pagination prevIcon={PREV_ICON} nextIcon={NEXT_ICON} showTitle={false} {...props} />
    </div>
  );
};

export default WkPagination;
